import React from 'react'

import { REFUND_TYPES } from './refund-types'

import Text from '@eig-builder/module-localization'
import '../lang'

export const getRefundOptions = (showCreditOption, hideNoneOption) => {
  return [
    ...(!hideNoneOption
      ? [
        {
          label: <Text message='modules.crm.components.account.refund.select.none' />,
          value: REFUND_TYPES.NONE
        }
      ]
      : []),
    {
      label: <Text message='modules.crm.components.account.refund.select.refund' />,
      value: REFUND_TYPES.REFUND
    },
    ...(showCreditOption
      ? [
        {
          label: <Text message='modules.crm.components.account.refund.select.credits' />,
          value: REFUND_TYPES.CREDITS
        }
      ]
      : [])
  ]
}
